module.exports = __webpack_public_path__ + "img/Banner-WritingHomeModelConcept.9ea5d73c.jpg";